export default __webpack_public_path__ + "static/media/whatsapp-img.fc20518d.svg";